import React from "react";
import { Button, Tooltip, Typography } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Text } = Typography;

const UserAccountMenu = ({
  userName,
  scopeName,
  resetPasswordPath,
  onLogout,
}) => (
  <div className="header-account">
    <div className="header-account__primary">
      <Link
        className="header-account__name"
        to={resetPasswordPath}
      >
        {userName || "-"}
      </Link>
      <Tooltip title="退出登录">
        <Button
          className="header-account__logout"
          type="text"
          size="small"
          icon={<LogoutOutlined />}
          aria-label="退出登录"
          onClick={onLogout}
        />
      </Tooltip>
    </div>
    <Text type="secondary" className="header-account__scope">
      {scopeName || "-"}
    </Text>
  </div>
);

export default UserAccountMenu;
